"use client";

import Image from "next/image";
import { Icons } from "@/components/icons";
import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { RichText } from "@graphcms/rich-text-react-renderer";
import Link from "next/link";

interface Props {
  triplet: any;
}

export default function Triplet({ triplet }: Props) {
  // TODO: Fix type
  const imageRef = useRef<HTMLImageElement>(null);

  //   useGSAP(() => {
  //     gsap.to(imageRef.current, {
  //       duration: 1,
  //       ease: "power4.inOut",
  //       scrollTrigger: {
  //         trigger: triplet.triplet?.url || "",
  //         start: "top top",
  //         end: "bottom bottom",
  //         scrub: true,
  //       },
  //     });
  //   });

  const count = triplet.tripletContentAboveGalleries.length;
  // console.log(count);
  let countClass = "w-full";

  if (count >= 3) {
    countClass = "w-full md:w-1/3";
  } else if (count == 2) {
    countClass = "w-full md:w-1/2";
  }

  const renderThis = (triplet: any) => {
    return !!(triplet.tripletTitleAboveGalleries || count > 0);
  };

  if (renderThis(triplet)) {
    return (
      <div className="cs-container mb-10">
        <h2 className="mb-10 text-center" dangerouslySetInnerHTML={{ __html: triplet.tripletTitleAboveGalleries }}></h2>
        <div className="flex flex-col flex-wrap justify-center md:flex-row">
          {triplet.tripletContentAboveGalleries.map((tripletContent: any, index: number) => (
            <div
              key={index}
              className={`mb-10 flex flex-col items-center justify-start text-center md:px-4 ${countClass}`}
            >
              {tripletContent.title && (
                <div className="mb-8 inline">
                  <h3 className="button-long relative mx-auto text-lg font-bold text-white sm:text-xl md:text-2xl">
                    <div className="strip"></div>
                    <span dangerouslySetInnerHTML={{ __html: tripletContent.title }}></span>
                  </h3>
                </div>
              )}
              <RichText
                content={tripletContent.content.raw}
                renderers={{
                  h3: ({ children }: any) => (
                    <div className="mb-8 inline">
                      <h3 className="button-long relative mx-auto text-lg font-bold text-white sm:text-xl md:text-2xl lg:text-3xl">
                        <div className="strip"></div>
                        {children}
                      </h3>
                    </div>
                  ),
                  ul: ({ children }: any) => (
                    <ul className="text-base-200 w-full list-inside list-none text-left md:w-auto">{children}</ul>
                  ),
                  li: ({ children }: any) => (
                    <li className="text-base-200 my-4 flex flex-row items-start text-base">
                      <div className="mr-4 mt-1">
                        <Icons.check />
                      </div>
                      {children}
                    </li>
                  ),
                }}
              />
            </div>
          ))}
        </div>
      </div>
    );
  }
}
